<template>
  <div class="container" style="margin-bottom: 10px">
    <div class="statContainer">
      <div class="nextStats">
        <div class="card stat">
          <div
            style="display: flex; justify-content: space-between; width: 100%"
          >
            <p class="title" style="margin-bottom: 0">Ventas Historial</p>
            <i
              @click="getReport"
              style="cursor: pointer"
              class="fas fa-sync text-sm opacity-10"
            ></i>
          </div>
          <div class="dateContainer">
            <div class="date-input">
              <label class="labelText" for="firstDay">Desde:</label>
              <input
                class="form-control"
                type="date"
                id="firstDay"
                v-model="firstDay"
                @change="getReport"
              />
            </div>
            <div class="date-input">
              <label class="labelText" for="lastDay">Hasta:</label>
              <input
                class="form-control"
                type="date"
                id="lastDay"
                v-model="lastDay"
                @change="getReport"
              />
            </div>
          </div>
          <div class="historicalDate">
            <div class="dateSpan">
              <p class="dateSpanText" style="margin-bottom: 0">
                Desde: {{ formatDate(this.firstDay) }}
              </p>
              <p class="dateSpanText" style="margin-bottom: 0">
                Hasta: {{ formatDate(this.lastDay) }}
              </p>
            </div>
            <Skeletor
              v-if="loadingReport"
              height="32"
              width="50"
              style="align-self: self-end"
            />
            <p v-else class="number" style="margin-bottom: 0">
              {{ this.conversionsListSize }}
            </p>
          </div>
        </div>
        <div class="card stat">
          <p class="title" style="margin-bottom: 0">Total Leads Históricos</p>
          <Skeletor
            v-if="loadingReport"
            height="32"
            width="50"
            style="align-self: self-end"
          />
          <p v-else class="number" style="margin-bottom: 0">
            {{ this.totalLeads }}
          </p>
        </div>
        <div class="card stat">
          <p class="title" style="margin-bottom: 0">Leads {{ presentMonth }}</p>
          <Skeletor
            v-if="loadingReport"
            height="32"
            width="50"
            style="align-self: self-end"
          />
          <p v-else class="number" style="margin-bottom: 0">
            {{ this.monthConversions + this.monthLeads }}
          </p>
        </div>
        <div class="card stat">
          <p class="title" style="margin-bottom: 0">
            Ventas {{ presentMonth }}
          </p>
          <Skeletor
            v-if="loadingReport"
            height="32"
            width="50"
            style="align-self: self-end"
          />
          <p v-else class="number" style="margin-bottom: 0">
            {{ this.monthConversions }}
          </p>
        </div>
        <div class="card stat">
          <p class="title" style="margin-bottom: 0">
            % Conversión {{ presentMonth }}
          </p>
          <Skeletor
            v-if="loadingReport"
            height="32"
            width="50"
            style="align-self: self-end"
          />
          <p v-else class="number" style="margin-bottom: 0">
            {{
              (
                (100 * this.monthConversions) /
                (this.monthConversions + this.monthLeads)
              ).toFixed(2)
            }}%
          </p>
        </div>
        <div class="card stat">
          <p class="title" style="margin-bottom: 0">Total Usuarios</p>
          <Skeletor
            v-if="loadingReport"
            height="36"
            width="80"
            style="align-self: flex-end"
          />
          <p v-else class="number" style="margin-bottom: 0">
            {{ this.totalUsers }}
          </p>
        </div>
      </div>
      <div
        class="graph-container"
        style="display: flex; flex-direction: column; gap: 20px"
      >
        <!-- First Graph: Nuevos Usuarios -->
        <div class="card" style="padding: 20px; height: fit-content">
          <p style="margin-bottom: 0">Gráfico de Nuevos Usuarios</p>
          <Skeletor v-if="loadingReport" height="100%" width="100%" style="" />
          <BarChart v-else :chartData="this.dailyRegisters" :styles="styles" />
        </div>

        <!-- Second Graph: Conversiones -->
        <div class="card" style="padding: 20px; height: fit-content">
          <p style="margin-bottom: 0">Gráfico de conversiones</p>
          <Skeletor v-if="loadingReport" height="100%" width="100%" style="" />
          <BarChart
            v-else
            :chartData="this.conversionsByDate"
            :styles="styles"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from "../../components/BarChart";
import moment from "moment";

export default {
  props: ["userId", "tokenAuth"],
  components: { BarChart },
  data() {
    const firstDayOfMonth = new Date(
      new Date().getFullYear(),
      new Date().getMonth(),
      1
    )
      .toISOString()
      .split("T")[0];
    const hasta = new Date().toISOString().split("T")[0];

    const monthNames = [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ];

    const today = new Date();
    const currentMonth = monthNames[today.getMonth()];
    return {
      loading: true,
      loadingReport: true,
      conversionsByDate: {
        labels: [],
        datasets: [{ data: [] }],
      },
      dailyRegisters: {
        labels: [],
        datasets: [{ data: [] }],
      },
      monthConversions: 0,
      monthLeads: 0,
      conversionsListSize: 0,
      totalUsers: 0,
      firstDay: firstDayOfMonth,
      lastDay: hasta,
      presentMonth: currentMonth,
    };
  },
  computed: {
    styles() {
      return { width: "100%" };
    },
  },
  watch: {},
  mounted() {
    this.getReport();
  },
  methods: {
    getReport() {
      this.loadingReport = true;
      this.$https
        .post("/administration/fetchSalesRecords", {
          tokenAuth: this.tokenAuth,
          firstDay: this.firstDay,
          lastDay: this.lastDay,
        })
        .then((response) => {
          this.totalUsers = response.data.totalUsers;
          this.conversionsListSize = response.data.conversionsListSize;
          this.monthConversions = response.data.monthConversions;
          this.totalLeads = response.data.totalLeads;
          this.monthLeads = response.data.notQualifiedListSize;
          let labels = [];
          let data = [];

          let conversionsByDate = response.data.conversionsListByDate.sort(
            (a, b) => {
              // Parse the 'dateFormatted' field into a Date object
              const dateA = moment(
                a.dateFormatted,
                "DD/MM/YYYY, HH:mm"
              ).toDate();
              const dateB = moment(
                b.dateFormatted,
                "DD/MM/YYYY, HH:mm"
              ).toDate();
              return dateA - dateB;
            }
          );

          // Object to hold count of conversions per date
          let countsByDate = {};

          conversionsByDate.forEach((dato) => {
            // Extract just the date part (without the time)
            const dateKey = moment(
              dato.dateFormatted,
              "DD/MM/YYYY, HH:mm"
            ).format("YYYY-MM-DD");

            // If it's the first conversion for this day, add a new entry in countsByDate
            if (!countsByDate[dateKey]) {
              countsByDate[dateKey] = 1;
            } else {
              countsByDate[dateKey] += 1;
            }
          });

          const startDate2 = new Date(this.firstDay);
          const endDate2 = new Date(this.lastDay);
          let currentDate = moment(startDate2); // Initialize currentDate as a moment object

          // Loop through each day in the range and add it to countsByDate if it's missing
          while (currentDate <= endDate2) {
            const dateKey = moment(currentDate).format("YYYY-MM-DD"); // Wrap currentDate with moment()
            if (!countsByDate[dateKey]) {
              countsByDate[dateKey] = 0; // If no conversion, set count to 0
            }
            currentDate.add(1, "days"); // Move to the next day
          }

          const sortedDates = Object.keys(countsByDate).sort(); // This sorts the dates in ascending order

          sortedDates.forEach((date) => {
            labels.push(date); // Add the date to the labels array
            data.push(countsByDate[date]); // Add the corresponding count to the data array
          });

          this.conversionsByDate = {
            labels, // The date ranges for the X-axis
            datasets: [
              {
                label: "Conversiones",
                data, // The count of conversions for each date
                backgroundColor: "#114d8c",
              },
            ],
          };

          // const conversionsByDate = test.sort((a, b) => {
          //   // Parse the 'dateFormatted' field into a Date object
          //   const dateA = moment(a.dateFormatted, "DD/MM/YYYY, HH:mm").toDate();
          //   const dateB = moment(b.dateFormatted, "DD/MM/YYYY, HH:mm").toDate();
          //   return dateA - dateB;
          // });

          // conversionsByDate.forEach((dato) => {
          //   // Parse the 'dateFormatted' to the desired format
          //   const formattedDate = moment(
          //     dato.dateFormatted,
          //     "DD/MM/YYYY, HH:mm"
          //   ).format("YYYY-MM-DD HH:mm");
          //   labels.push(formattedDate); // Push formatted date as label

          //   // You can push the count or other data here. Assuming the "data" field you want is a count, you might push something like this:
          //   data.push(1); // Adjust this according to your needs, i.e., total number of conversions for that date
          // });

          // this.conversionsByDate = {
          //   labels, // The date ranges (start and end) for the X-axis
          //   datasets: [
          //     {
          //       label: "Conversiones",
          //       data, // The count or number of conversions for each date range
          //       backgroundColor: "#114d8c",
          //     },
          //   ],
          // };
          const dailyLabels = [];
          const dailyCounts = [];
          const dailyData = response.data.dailyRegisters;

          // Determine the start and end dates from the response data
          const generateDateRange = (start, end) => {
            const dateRange = [];
            const currentDate = new Date(start);
            while (currentDate <= end) {
              dateRange.push(new Date(currentDate));
              currentDate.setDate(currentDate.getDate() + 1); // Move to next day
            }
            return dateRange;
          };
          const startDate = new Date(
            Math.min(...dailyData.map((item) => new Date(item.date)))
          );
          const endDate = new Date(
            Math.max(...dailyData.map((item) => new Date(item.date)))
          );

          const allDates = generateDateRange(startDate, endDate);
          allDates.forEach((date) => {
            const dateStr = date.toISOString().split("T")[0]; // Format date as YYYY-MM-DD
            const existingData = dailyData.find(
              (item) => item.date === dateStr
            );

            dailyLabels.push(dateStr); // Push the date as a label
            dailyCounts.push(existingData ? existingData.count : 0); // If no data, set count as 0
          });

          this.dailyRegisters = {
            labels: dailyLabels, // Dates for the X-axis
            datasets: [
              {
                label: "Usuarios registrados",
                data: dailyCounts, // Counts for each date
                backgroundColor: "#114d8c",
              },
            ],
          };

          this.loadingReport = false;
        })
        .catch((error) => {
          console.error("Error:", error);
          this.$toast.error("Ocurrió un error", {
            position: "top-right",
            max: 10,
          });
          this.loadingReport = false;
        });
    },
    formatDate(date) {
      const d = date.split("-");
      const day = d[2];
      const month = d[1];
      const year = d[0];
      return `${day}/${month}/${year}`;
    },
    // Reusable function to generate chart data for date ranges
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

.container {
  display: flex;
  gap: 12px;
  flex-direction: column;
}

.stat {
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #333333;
  .title {
    align-self: self-start;
    font-size: 18px;
    font-weight: 600;
  }
  .number {
    align-self: self-end;
    font-size: 24px;
    font-weight: 800;
    margin: 0;
    line-height: 1.2;
  }
}

@media (max-width: 550px) {
  .stat {
    width: 100%;
  }

  .date-input {
    width: 100%;
  }
}

.dateSpan {
  display: flex;
  flex-direction: column;
}

.dateSpanText {
  font-size: 12px;
  font-weight: 500;
  color: #7c7c7c;
}

.historicalDate {
  width: 100%;
  display: flex;
  gap: 20px;
  justify-content: space-between;
}

.statContainer {
  display: flex;
  gap: 12px;
  //   flex-wrap: wrap;
}

@media (max-width: 1200px) {
  .statContainer {
    flex-direction: column;
  }
}

.dateContainer {
  display: flex;
  gap: 12px;
  align-self: flex-start;
}

.labelText {
  font-size: 14px;
  margin: 0;
}

.date-input {
  display: flex;
  align-items: center;
  flex-direction: column;
  align-items: start;
}

.nextStats {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.graph-container {
  display: flex;
  flex-direction: column;
  gap: 20px; /* Adjust space between the graphs */
  width: 100%;
}
</style>
